export enum DigitalIDMethod {
    BANKID = 'BANKID',
}

export function DigitalIDMethodToLabel(method: DigitalIDMethod): string {
    switch (method) {
        case DigitalIDMethod.BANKID:
            return 'BankID';
    }
}

export enum RESOURCE_TYPE {
    ASSIGNMENT = 'assignment',
}

export interface File {
    id: number;
    uuid: string;
    date: string;
    name: string;
    size: number;
    type: string;
    uploader: Uploader;
    isGenerated: boolean;
    requiresSignature: boolean;
    fileSigning: FileSigning | null;
}

export interface FileSigning {
    internalSignature: FileSigningSignature | null;
    externalSignature: FileSigningSignature | null;
}

export interface FileSigningSignature {
    signerName: string;
    signerSurname: string;
    digitalIDMethod: DigitalIDMethod;
    signedAt: string;
}

export interface Uploader {
    name: string;
    surname: string;
    isStaff: boolean;
}
